import React, { useEffect, useState } from "react"
import { getTailwindValue } from "~/utils/tailwind"

export default function HakioLogo({
  color = getTailwindValue("--color-primary-300"),
  hoverColor = getTailwindValue("--color-primary-200"),
  width = "104",
  height = "20",
}) {
  const [currentColor, setCurrentColor] = useState(color)

  useEffect(() => {
    setCurrentColor(color)
  }, [color])

  const handleMouseEnter = () => {
    if (hoverColor !== "") {
      setCurrentColor(hoverColor)
    }
  }

  const handleMouseLeave = () => {
    setCurrentColor(color)
  }

  return (
    <svg
      fill="none"
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <g
        id="c86df1c3f114e2aaeaec6500dbae948daa99ee68-1004x191 1"
        clipPath="url(#clip0_15629_51613)"
      >
        <path
          id="Vector"
          d="M38.5014 2.77C37.8505 1.87527 37.0142 1.18873 35.9923 0.713556C34.9689 0.236792 33.8165 0 32.5321 0C30.6864 0 29.0372 0.429086 27.5799 1.28885C26.1241 2.15021 24.9874 3.33735 24.1731 4.85505C23.3588 6.37274 22.9531 8.08274 22.9531 9.98504C22.9531 11.8873 23.3588 13.5957 24.1731 15.1134C24.9874 16.6327 26.1225 17.8199 27.5799 18.6796C29.0357 19.5394 30.6864 19.9685 32.5321 19.9685C33.8165 19.9685 34.9704 19.7317 35.9923 19.2549C37.0142 18.7798 37.8489 18.0948 38.5014 17.1984V19.6109H42.8435V0.411606H38.5014V2.77ZM37.8914 12.9617C37.4119 13.8293 36.7517 14.5111 35.9106 15.0053C35.0694 15.4996 34.1058 15.7444 33.0194 15.7444C31.9519 15.7444 30.9945 15.498 30.144 15.0053C29.2919 14.5111 28.6269 13.8293 28.1474 12.9617C27.6695 12.0939 27.429 11.1023 27.429 9.98663C27.429 8.87099 27.6695 7.87932 28.1474 7.01002C28.6269 6.14231 29.2919 5.46054 30.144 4.96629C30.9945 4.47205 31.9519 4.22731 33.0194 4.22731C34.1058 4.22731 35.0679 4.47364 35.9106 4.96629C36.7517 5.46054 37.4119 6.14231 37.8914 7.01002C38.3709 7.87932 38.6099 8.87258 38.6099 9.98663C38.6099 11.1006 38.3709 12.0939 37.8914 12.9617Z"
          fill={currentColor}
        />
        <path
          id="Vector_2"
          d="M15.6285 0.41156V7.76168H4.4491V0.41156H0V19.6124H4.4491V11.8778H15.6285V19.6124H20.0759V0.41156H15.6285Z"
          fill={currentColor}
        />
        <path
          id="Vector_3"
          d="M50.9559 0.411592H46.5068V19.6125H50.9559V13.173L63.709 19.8048V14.5937L53.5357 9.98502L63.709 5.21102V0.219299L50.9559 6.85109V0.411592Z"
          fill={currentColor}
        />
        <path
          id="Vector_4"
          d="M72.123 0.41156H65.9902V4.52604H72.123V15.498H65.9902V19.6124H72.123H76.5721H82.7034V15.498H76.5721V4.52604H82.7034V0.41156H76.5721H72.123Z"
          fill={currentColor}
        />
        <path
          id="Vector_5"
          d="M102.688 4.85499C101.846 3.33728 100.666 2.15014 99.1472 1.29038C97.6253 0.430612 95.907 0.00152588 93.9906 0.00152588C92.0742 0.00152588 90.3605 0.430612 88.8482 1.29038C87.3374 2.15014 86.1567 3.33728 85.3062 4.85499C84.4557 6.37427 84.0312 8.08267 84.0312 9.98496C84.0312 11.8872 84.4557 13.5957 85.3062 15.115C86.1567 16.6327 87.3358 17.8198 88.8482 18.6796C90.359 19.5409 92.0726 19.97 93.9906 19.97C95.9086 19.97 97.6269 19.5409 99.1472 18.6796C100.666 17.8198 101.846 16.6327 102.688 15.115C103.529 13.5957 103.948 11.8872 103.948 9.98496C103.948 8.08267 103.529 6.37427 102.688 4.85499ZM98.685 12.8519C98.2322 13.7022 97.5939 14.3696 96.7732 14.8543C95.9494 15.339 95.0219 15.5822 93.9906 15.5822C92.9593 15.5822 92.038 15.339 91.2237 14.8543C90.4093 14.3696 89.7726 13.7022 89.3104 12.8519C88.8497 12.0017 88.6186 11.0466 88.6186 9.98496C88.6186 8.92496 88.8497 7.96825 89.3104 7.11802C89.7726 6.2678 90.4109 5.60033 91.2237 5.11561C92.038 4.6309 92.9593 4.38775 93.9906 4.38775C95.0219 4.38775 95.9494 4.6309 96.7732 5.11561C97.5939 5.60033 98.2322 6.2678 98.685 7.11802C99.1377 7.96825 99.3641 8.92496 99.3641 9.98496C99.3641 11.0466 99.1377 12.0017 98.685 12.8519Z"
          fill={currentColor}
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_15629_51613">
          <rect width={width} height={width} fill="white" />
        </clipPath>
      </defs> */}
    </svg>
  )
}
